import { ROUTES } from "./";

export const MANAGE_PAYROLL_ROUTES = {
  NEW_PAYROLL_UPLOAD: `${ROUTES.MANAGE_PAYROLL}/upload-file`,
  CREATE_OR_GENERATE: `${ROUTES.MANAGE_PAYROLL}/create-or-generate`,
  GENERATE_OUTPUT: `${ROUTES.MANAGE_PAYROLL}/generate-output`,
  VIEW_OUTPUT: `${ROUTES.MANAGE_PAYROLL}/view-output`,
  CREATE_PAYROLL_LISTING: `/create-payroll-listing`,
  UPLOADED_FILES_LISTING: `${ROUTES.PAYROLL}`,
  CENSUS_AND_PAYROLL: `${ROUTES.PAYROLL}/census-and-payroll`,
  // PAYROLL_FILE_STATUS: `${ROUTES.MANAGE_PAYROLL}/payroll-file-status`,
  BASIC_INFORMATION: `${ROUTES.MANAGE_TEMPMAP}/basic-information`,
  FIXED_LENGTH: `${ROUTES.MANAGE_TEMPMAP}/fixed-length`,
  MAP_AND_TRANSFORM: `${ROUTES.MANAGE_TEMPMAP}/map-and-transform`,
  VERIFY_MAP: `${ROUTES.MANAGE_TEMPMAP}/verify-map`,
};
export const FILE_UPLOAD_STATUS = {
  CreationInProgress: "CreationInProgress",
  ErrorCorrectionRequired: "ErrorCorrectionRequired",
  PendingSubmission: "PendingSubmission",
  AwaitingFunding: "AwaitingFunding",
  UploadInProgress: "UploadInProgress",
  AwaitingTrade: "AwaitingTrade",
  Completed: "Completed",
  Cancelled: "Cancelled",
  Deleted: "Deleted",
  StructuralValidationFailed: "StructuralValidationFailed",
  SystemFailure: "SystemFailure",
  FileUploadInProgress: "FileUploadInProgress",
  AwaitingFundConfirmation: "AwaitingFundConfirmation",
  PayrollFunded: "PayrollFunded",
  FundingFailed: "FundingFailed",
  PayrollFundingInProgress: "PayrollFundingInProgress",
};
export const MANAGE_PAYROLL_MENU = [
  {
    id: "uploadFile",
    label: "Upload file",
    path: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
    contentHeader: "Upload Payroll & Census Files",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "createOrGenerate",
    label: "Create or Generate",
    path: MANAGE_PAYROLL_ROUTES.CREATE_OR_GENERATE,
    contentHeader: "Payroll & Census",
    breadCrumbs: [],
    childRoutes: [],
  },
  // {
  //   label: "Common Remitters",
  //   path: MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT,
  //   contentHeader: "Payroll & Census Files",
  //   breadCrumbs: [],
  //   childRoutes: [],
  //   subRoutes: [
  //     {
  //       label: "Generate Output",
  //       path: MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT,
  //       contentHeader: "Payroll & Census Files",
  //       breadCrumbs: [],
  //       childRoutes: [],
  //     },
  //     {
  //       label: "View Output",
  //       path: MANAGE_PAYROLL_ROUTES.VIEW_OUTPUT,
  //       contentHeader: "Payroll & Census Files",
  //       breadCrumbs: [],
  //       childRoutes: [],
  //     },
  //   ],
  // },
];

export const ALL_MANAGE_PAYROLL_ROUTES = [
  ...MANAGE_PAYROLL_MENU,
  {
    id: "uploadFile",
    contentHeader: "Upload file",
    path: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
    breadCrumbs: [
      {
        label: "Payroll & Census Files",
        link: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
      },
    ],
  },
  {
    id: "createOrGenerate",
    contentHeader: "Create or Generate",
    path: MANAGE_PAYROLL_ROUTES.CREATE_OR_GENERATE,
    breadCrumbs: [
      {
        label: "Payroll & Census",
        link: MANAGE_PAYROLL_ROUTES.CREATE_OR_GENERATE,
      },
    ],
  },
  {
    contentHeader: "Generate Output",
    path: MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT,
    breadCrumbs: [
      {
        label: "Payroll & Census Files",
        link: MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT,
      },
    ],
  },
];

export const MANAGE_TEMPMAP_MENU = [
  {
    id: "loadDefinitionHome",
    label: "Source",
    contentHeader: "Source",
    path: MANAGE_PAYROLL_ROUTES.BASIC_INFORMATION,
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "fixedLength",
    label: "File Specifications",
    path: MANAGE_PAYROLL_ROUTES.FIXED_LENGTH,
    contentHeader: "File Specifications",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "mapAndTransform",
    label: "Map & Transform",
    path: MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM,
    contentHeader: "Map & Transform",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "verifyMap",
    label: "Verify Map",
    path: MANAGE_PAYROLL_ROUTES.VERIFY_MAP,
    contentHeader: "Verify Map",
    breadCrumbs: [],
    childRoutes: [],
  },
];
export const ALL_MANAGE_TEMPMAP_ROUTES = [
  ...MANAGE_TEMPMAP_MENU,
  {
    id: "mapAndTransform",
    contentHeader: "Payroll",
    path: MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM,
    breadCrumbs: [
      // {
      //   label: "Manage Reports",
      //   link: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
      // },
    ],
  },
];

export const managePayrollFormNames = {
  PAYROLL_FILTER: "payroll filter",
  UPLOAD_FILE: "upload file",
  CREATE_OR_GENERATE_FILE: "create or generate file",
  EDIT_CONTRIBUTION: "edit contribution",
  EMPLOYEE_WIZARD: "employee wizard",
  ERROR_CORRECTION_FORM: "error_correction_form",
  FORFEITURE_FUNDING: "forfeiture_funding",
  CREATE_PAYROLL_LISTING: "create_payroll_listing",
};

export const payrollFormFields = {
  [managePayrollFormNames.PAYROLL_FILTER]: {
    companyId: "companyId",
    companyName: "companyName",
    planId: "planId",
    planGroupId: "planGroupId",
    planGroupName: "planGroupName",
    planName: "planName",
    rkPlanNumber: "rkPlanNumber",
    fileStatus: "fileStatus",
    fromDate: "fromDate",
    toDate: "toDate",
    paydateFrom: "paydateFrom",
    paydateTo: "paydateTo",
    type: "type",
  },
  [managePayrollFormNames.UPLOAD_FILE]: {
    template: "fileType",
    inputType: "inputType",
    format: "format",
    uploadCensusAndPayroll: "uploadCensusAndPayroll",
    description: "description",
    isSFTP: "isSFTP",
    isMultiplePlanOrPaydate: "isMultiplePlanOrPaydate",
    planId: "planId",
    payDate: "payDate",
  },
  [managePayrollFormNames.CREATE_OR_GENERATE_FILE]: {
    companyId: "companyId",
    planId: "planId",
    payrollFrequencyId: "payrollFrequencyId",
    payDate: "payDate",
    description: "description",
  },
  [managePayrollFormNames.EDIT_CONTRIBUTION]: {
    afterTax: "afterTax",
    employerMatch: "employerMatch",
    nonElectiveContribution: "nonElectiveContribution",
    preTax: "preTax",
    roth: "roth",
    payperiodHours: "payperiodHours",
    Compensation: "Compensation",
    YTDhours: "YTDhours",
    YTDCompensation: "YTDCompensation",
    loanRepayment: "loanRepayment",
  },
  [managePayrollFormNames.EMPLOYEE_WIZARD]: {
    employeeFirstName: "employeeFirstName",
    employeeMiddleName: "employeeMiddleName",
    employeeLastName: "employeeLastName",
    socialSecurityNumber: "socialSecurityNumber",
    companyName: "companyName",
    employeeId: "employeeId",
    payrollFrequency: "payrollFrequency",
    gender: "gender",
    maritalStatus: "maritalStatus",
    email: "email",
    phoneNumber: "phoneNumber",
    addressName: "addressName",
    addressOne: "addressOne",
    addressTwo: "addressTwo",
    addressThree: "addressThree",
    city: "city",
    country: "country",
    state: "state",
    zipCode: "zipCode",
    additionalAddressName: "additionalAddressName",
    additionalAddressOne: "additionalAddressOne",
    additionalAddressTwo: "additionalAddressTwo",
    additionalAddressThree: "additionalAddressThree",
    additionalCity: "additionalCity",
    additionalForeignAddress: "additionalForeignAddress",
    additionalCountry: "additionalCountry",
    additionalState: "additionalState",
    additionalzipCode: "additionalZipCode",
    birthDate: "birthDate",
    hireDate: "hireDate",
    employmentStatus: "employmentStatus",
    mostRecentTermDate: "mostRecentTermDate",
    mostRecentRehireDate: "mostRecentRehireDate",
    classificationType: "classificationType",
    classificationCode: "classificationCode",
    classificationName: "classificationName",
    startDate: "startDate",
    endDate: "endDate",
    pendingQDRO: "pendingQDRO",
    ownership: "ownership",
    SSNofOwner: "SSNofOwner",
    returnMailIndicator: "returnMailIndicator",
    officer: "officer",
    HCE: "HCE",
    keyEmployee: "keyEmployee",
    restrictedEmployee: "restrictedEmployee",
  },
  [managePayrollFormNames.ERROR_CORRECTION_FORM]: {
    firstName: "firstName",
    middleName: "middleName",
    lastName: "lastName",
    gender: "gender",
    maritalStatus: "maritalStatus",
    birthDate: "birthDate",
    uniquePersonalIdentification: "uniquePersonalIdentification",
    primaryEmailAddress: "primaryEmailAddress",
    phone: "mobilePhoneNumber",
    city: "city",
    country: "country",
    countryCode: "countryCode",
    countryId: "countryId",
    foreignCountry: "foreignCountry",
    foreignState: "foreignState",
    state: "state",
    stateId: "stateId",
    zipCode: "zipCode",
    mobilePhoneNumber: "mobilePhoneNumber",
    workPhoneNumber: "workPhoneNumber",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    hireDate: "hireDate",
    employmentStatusId: "employmentStatusId",
    employmentStatus: "employmentStatus",
    employeeId: "employeeId",
    familyMemberOfOwnerIndicator: "familyMemberOfOwnerIndicator",
    employmentStatus: "employmentStatus",
    mostRecentTermDate: "terminationDate",
    reHireDate: "reHireDate",
    leaveStartDate: "leaveStartDate",
    leaveEndDate: "leaveEndDate",
    pendingQDROIndicator: "pendingQDROIndicator",
    officerIndicator: "officerIndicator",
    ownerShip: "ownerShip",
    relationUniquePersonalIdentification:
      "relationUniquePersonalIdentification",
    ssnOfOwner: "ssnOfOwner",
    returnMailIndicator: "returnMailIndicator",
    isOfficer: "isOfficer",
    isHCE: "hCEIndicator",
    hceIndicator: "hceIndicator",
    keyEmployeeIndicator: "keyEmployeeIndicator",
    insiderOrRestrictedEmployeeIndicator:
      "insiderOrRestrictedEmployeeIndicator",
    companyName: "companyName",
    modeOfHours: "modeOfHours",
    annualSalary: "annualSalary",
    ytdHours: "ytdHours",
    payPeriodHours: "payPeriodHours",
    payrollFrequency: "payrollFrequency",
    payrollFrequencyId: "payrollFrequencyId",
    employeeNumber: "employeeNumber",

    compensationDetails: "compensations",
    contributionsDetails: "contributions",
    deletedContributionIds: "deletedContributionIds",
    deletedLoanIds: "deletedLoanIds",
    loanDetails: "loanDetails",
    errorReport: "errorReport",
    payrollLoans: "payrollLoans",
    compensationDetailsRecordType: "compensationDetailsRecordType",
    paydate: "paydate",
    paydateContribution: "paydateContribution",
    paydateError: "paydateError",
    contributionDetailsRecordType: "contributionDetailsRecordType",
    errorReportRecordType: "errorReportRecordType",
    payrollLoansRecordType: "payrollLoansRecordType",
  },
  [managePayrollFormNames.CREATE_PAYROLL_LISTING]: {
    id: "id",
    hours: "hours",
    planCompensation: "planCompensation",
    grossCompensation: "grossCompensation",
    annualSalary: "annualSalary",
    contributions: "contributions",
    employeeTab: "employeeTab",
    payrollDetails: "payrollDetails",
  },
  [managePayrollFormNames.FORFEITURE_FUNDING]: {
    bankFundings: "bankFundings",
    forfeitureFundings: "forfeitureFundings",
    achDebitFundings: "achDebitFundings",
  },
};

export const PAYROLL_RECORDS_TO_FETCH = 20;
